<div class="flex flex-col align-middle relative items-center text-slate-900 stroke-faded-50 hover:stroke-faded-90 hover:cursor-default">
    <button (click)="onDeckFavoriteClicked()">
        <svg class="w-6 h-6" [ngClass]="{ 'fill-faded-70' : deck.isFavorited, 'fill-none' : !deck.isFavorited }" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-width="1">
            <title>Favorite</title>
            <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="starSvgIcon" />
        </svg>
    </button>
</div>